<template>
    <kb-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h3 style="padding-top:0">Create a New Draft</h3>

        <div style='clear: both; padding-right: 1.0rem; padding-top: 1.0rem;' v-if='(!isAuthenticated || !isSubscriber)'>
                <subscriber-login-prompt/>
            </div>
        <div v-if='isAuthenticated && isSubscriber'>
            Choose initial values for creating your new draft.  It is easy to change these later while editing.
        </div>
        <div class='top-padding' v-if='isAuthenticated && isSubscriber'>
            Title (optional): <kb-form-input v-model='draftTitle'/>
        </div>
        <div v-if='isAuthenticated && isSubscriber'>
            <div class='inline-auto-width small-top-padding right-padding'>Shafts:&nbsp;<kb-form-select v-model="shaftsCount" :options='shaftsOptions' /></div>
            <div class='inline-auto-width small-top-padding right-padding'>Treadles:&nbsp;<kb-form-select v-model="treadlesCount" :options='treadlesOptions' /></div>
            <div class='inline-auto-width small-top-padding right-padding'>Warp&nbsp;Threads:&nbsp;<kb-form-select v-model="warpThreadsCount" :options='warpThreadsOptions' /></div>
            <div class='inline-auto-width small-top-padding right-padding'>Weft&nbsp;Threads:&nbsp;<kb-form-select v-model="weftThreadsCount" :options='weftThreadsOptions' /></div>
            <div class='inline-auto-width small-top-padding right-padding'>Threading:&nbsp;<kb-form-select v-model="initialThreading" :options='initialThreadingOptions' /></div>
            <div class='inline-auto-width small-top-padding right-padding'>Treadling:&nbsp;<kb-form-select v-model="initialTreadling" :options='initialThreadingOptions' /></div>
        </div>
        <div v-if='isAuthenticated && isSubscriber' class='top-padding'>
            <kb-button variant='primary' @click="createNewDraftAndNavigateToEditor">Create Draft</kb-button>
        </div>
    </kb-container>
</template>

<script>

import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'
import draftEditingUtils from '../mixins/draftEditingUtils.js'
import draftToolsState from '../mixins/draftToolsState.js'
import draftEditorService from '../mixins/draftEditorService.js'
import urlsService from '../mixins/urlsService.js'
import utilityService from '../mixins/utilityService.js'

export default {
    mixins: [draftEditingUtils, draftToolsState, draftEditorService, urlsService, utilityService],
    components: {
        subscriberLoginPrompt: subscriberLoginPrompt
    },
    data: function() {
        return {
            shaftsCount: 4,
            treadlesCount: 4,
            warpThreadsCount: 40,
            weftThreadsCount: 40,
            draftTitle: 'New Draft',
            initialThreading: 'none',
            initialTreadling: 'none',
            initialThreadingOptions: [{ text: 'None', value: 'none' }, { text: 'Straight', value: 'straight' }, { text: 'Point', value: 'point' }]
        }
    },
    methods: {
        generateNumericOptionsList(defaultPrompt, defaultValue, numericValuesArray) {
            let options = []
            if (defaultPrompt && defaultValue) {
                options.push({ text: defaultPrompt, value: defaultValue })
            }
            for (let c=0; c<numericValuesArray.length; c++) {
                let val = numericValuesArray[c]
                options.push({ text: val + '', value: val })
            }
            return options
        },

        generateNumbersArray(min, max, incAmount) {
            let a = []
            for (let k=min; k<=max; k+=incAmount) {
                a.push(k)
            }
            return a
        },

        createNewDraftAndNavigateToEditor() {
            let draft = this.createNewDraft()
            this.setToolsDraftJSON(draft)
            this.setToolsDraftSource(0, this.baseFilename, this.displayTitle)
            this.loadDraftEditor()
        },

        createNewDraft() {
            let draft = this.emptyDraft(this.shaftsCount, this.treadlesCount, this.warpThreadsCount, this.weftThreadsCount)
            let threadingGrid = []
            let treadlingGrid = []
            // console.log('draft: ' + JSON.stringify(draft))
            // console.log('initialThreading: ' + this.initialThreading)
            // console.log('initialTreadling: ' + this.initialTreadling)

            if (this.initialThreading === 'point') {
                // console.log('here 1')
                threadingGrid = this.buildPointThreaded2dRowMajorGrid(this.shaftsCount, this.warpThreadsCount, true)
                // console.log('point threadingGrid: ' + JSON.stringify(threadingGrid))
                this.loadDraftJSONFromNativeOrderThreadingArray(threadingGrid, draft, false)
            }
            // console.log('here 2...')
            if (this.initialThreading === 'straight') {
                // console.log('here 2')
                threadingGrid = this.buildStraightThreaded2dRowMajorGrid(this.shaftsCount, this.warpThreadsCount, true)
                this.loadDraftJSONFromNativeOrderThreadingArray(threadingGrid, draft, false)
            }
            if (this.initialTreadling === 'point') {
                // console.log('here 3')
                treadlingGrid = this.buildPointThreaded2dRowMajorGrid(this.weftThreadsCount, this.treadlesCount, false)
                // console.log('point treadlingGrid: ' + JSON.stringify(treadlingGrid))
                this.loadDraftJSONFromNativeOrderTreadlingArray(treadlingGrid, draft, false)
            }
            if (this.initialTreadling === 'straight') {
                // console.log('here 4')
                treadlingGrid = this.buildStraightThreaded2dRowMajorGrid(this.weftThreadsCount, this.treadlesCount, false)
                this.loadDraftJSONFromNativeOrderTreadlingArray(treadlingGrid, draft, false)
            }
            return draft
        },

        loadDraftEditor() {
            let draftEditorUrl = this.buildEditDraftUrl(true)
            // console.log('loadDraftEditor, url: ' + draftEditorUrl)
            this.$router.push(draftEditorUrl)
        }
    },

    watch: {
    },

    computed: {

        shaftsOptions: function() {
            return this.generateNumericOptionsList(null, null, this.generateNumbersArray(2, 64, 1))
        },

        treadlesOptions: function() {
            return this.generateNumericOptionsList(null, null, this.generateNumbersArray(2, 64, 1))
        },

        warpThreadsOptions: function() {
            return this.generateNumericOptionsList(null, null, this.generateNumbersArray(4, 500, 4))
        },

        weftThreadsOptions: function() {
            return this.generateNumericOptionsList(null, null, this.generateNumbersArray(4, 500, 4))
        },

        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },

        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },

        authUser: function() {
            return this.$store.state.authUser
        },

        baseFilename: function() {
            let fn = this.draftTitle.trim().toLowerCase()
            fn = this.alphanumericCharsOnly(fn)
            let wifName = fn.length > 0 ? fn : 'draft'
            wifName = wifName.replace('.wif', '') // in case someone adds .wif to the title, remove that so we don't add it twice
            wifName += '.wif'
            return wifName
        },

        displayTitle: function() {
            let title = this.draftTitle.trim()
            return title.length > 0 ? title : 'Draft'
        }
    },
    created() {
    }
}
</script>
